import React, { useState } from "react";
import { printAmount } from "common/src/helpers/functions";
import "common/src/assets/css/tables.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TournamentTable from "common/src/component/TournamentTable";
import {
  StyledTables,
  TablesWrapper,
  TableTitlePar,
  WinnerWrapper,
  WinnersTables,
  WinnerTitles,
  Winner,
  WinnerText,
  WinnerAmount,
  WinnerDetails,
  StyledPlayNow,
  StyledTableTournament,
  ShowAll,
  SeceontTableTitle,
  WinnerImg,
  StyledTournamentTable,
} from "../styledComponents/StyledTables";
import { SidePanelTable } from "../styledComponents/StyledGame";
import { useApolloClient } from "@apollo/client";
import { QUERY_GET_RECENT_WINNERS } from "../graphql/queries";

const Tables = ({
  server,
  playerCurrency,
  tournamentGame,
  gameImagePath,
  skin,
}) => {
  const { t } = useTranslation("");
  const [showAll, setShowAll] = useState(false);
  const [showTournamentPopover, setShowTournamentPopover] = useState(false);
  const [recentWinners, setRecentWinners] = useState(null);
  const apolloClient = useApolloClient();

  useEffect(() => {
    const getRecentWiners = async (currency) => {
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_RECENT_WINNERS,
        variables: { currency: currency },
      });
      if (loading) return <h3>Loading ...</h3>;
      if (errors) return <h1>`Error: ${errors}`</h1>;
      setRecentWinners(data.getRecentWinners);
      return null;
    };
    getRecentWiners(currency);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apolloClient]);

  return (
    <StyledTables>
      <TablesWrapper>
        <WinnersTables>
          <WinnerTitles>
            <TableTitlePar>
              {t("label_recent_winners", "Recent Winners")}
            </TableTitlePar>
          </WinnerTitles>
          <br />
          <WinnerWrapper>
            {/* map winners */}
            {recentWinners &&
              recentWinners.recent.slice(0, 4).map((winner, index) => {
                let WebPimg =
                  winner.banner.match(/\.(webp)/g) !== null
                    ? winner.banner.replace(".webp", "_big_lobby.webp")
                    : winner.banner.match(/\.(jpg)/g) !== null
                      ? winner.banner.replace(".jpg", "_big_lobby.webp")
                      : winner.banner.replace(".png", "_big_lobby.webp");
                let img = winner.banner.match(/\.(jpg)/g) !== null;
                winner.banner.match(/\.(jpg)/g) !== null
                  ? winner.banner.replace(".jpg", "_big_lobby.jpg")
                  : winner.banner.replace(".png", "_big_lobby.png");
                return (
                  <WinnerImg key={index}>
                    <picture>
                      <source
                        srcSet={
                          server.cdn
                            .replace("http:", "")
                            .replace("https:", "") +
                          gameImagePath +
                          WebPimg
                        }
                        type="image/webp"
                      />
                      <img
                        alt=""
                        srcSet={
                          server.cdn
                            .replace("http:", "")
                            .replace("https:", "") +
                          gameImagePath +
                          img
                        }
                      />
                    </picture>

                    <Winner>
                      <WinnerText>
                        <WinnerAmount>
                          {printAmount(
                            winner.win,
                            playerCurrency ? playerCurrency : "eur",
                            server.currencies,
                            false
                          )}
                        </WinnerAmount>
                        <Link to={winner.gameType + "/" + winner.details}>
                          <StyledPlayNow
                            srcSet={
                              require("../../../rac/src/data/img/playnow.svg")
                                .default
                            }
                            alt=""
                          />
                        </Link>
                      </WinnerText>
                      <WinnerDetails>
                        <b>{winner.gameID}</b>
                        <br />
                        {winner.firstName}
                      </WinnerDetails>
                    </Winner>
                  </WinnerImg>
                );
              })}
          </WinnerWrapper>
        </WinnersTables>

        <StyledTournamentTable>
          <SeceontTableTitle>
            <TableTitlePar>
              {t("label_tournament_leaderboard", "Tournament Leaderboard")}
            </TableTitlePar>
            <span onClick={() => setShowAll(!showAll)}>
              {!showAll && <p className="showall">{t("label_show_all")}</p>}
            </span>
          </SeceontTableTitle>
          <br />

          <StyledTableTournament>
            <thead>
              <tr>
                <th>{t("label_player")}</th>
                <th>{t("label_tournament_name")}</th>
                <th>{t("label_prize")}</th>
              </tr>
            </thead>
            <SidePanelTable as="tbody" showAll={showAll}>
              <TournamentTable
                playerCurrency={playerCurrency}
                showAll={showAll}
                server={server}
                displayName={true}
                tournamentGame={tournamentGame}
                showTournamentPopover={showTournamentPopover}
                skin={skin}
                setShowTournamentPopover={() =>
                  setShowTournamentPopover(!showTournamentPopover)
                }
              />
            </SidePanelTable>
          </StyledTableTournament>
          <ShowAll
            onClick={() => setShowTournamentPopover(!showTournamentPopover)}
          >
            {tournamentGame !== null
              ? t("label_tournament_information")
              : t("label_without_tournament_information")}
          </ShowAll>
        </StyledTournamentTable>
      </TablesWrapper>
    </StyledTables>
  );
};

export default Tables;
